import { defineComponent as _defineComponent } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoEducationalBackgrounds from '@/components/formats/RirekishoParts/AutoEducationalBackgrounds.vue'
import CareerYagiofferResetDialog from '@/components/format-edit/career-yagioffer/CareerYagiofferResetDialog.vue'
import gradeYearOptions from '@/utils/format-edit/newYagiofferGradeYearOptions.json'
import { useNewYagiofferFormatData } from '@/composables/format-edit/useNewYagiofferFormat'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewYagiofferEduHistoryCard',
  props: {
    basicData: null,
    currentCardId: null,
    previewErrors: null,
    activeHistoryItem: null,
    educationalResetVisible: { type: Boolean },
    descriptionMaxLength: null
  },
  emits: [
  'set-educational-backgrounds',
  'update:educational-reset-visible',
  'reset-educational-backgrounds',
  'add-educational-history',
  'delete-educational-history',
  'move-educational-history',
  'activate-history-item'
],
  setup(__props: any, { emit }) {





const formatData = useNewYagiofferFormatData()

function onAddEducationalHistory(
  index?: number,
  columns?: { year?: number; month?: number; description?: string }
) {
  emit('add-educational-history', index, columns)
}

return { __sfc: true,emit, formatData, onAddEducationalHistory, HistoryItem, AutoEducationalBackgrounds, CareerYagiofferResetDialog, gradeYearOptions }
}

})